import React, {useState, useEffect} from 'react'
import MaterialTable from "material-table";
import swal from "sweetalert";
import {Button, Col, Dropdown, DropdownButton, Form, FormControl, InputGroup, Row} from "react-bootstrap";
import {AddIconOutline, FilterIcon, MenuDots, SearchIcon} from "../../components/SvgIcons";
import {Link} from 'react-router-dom';
import {CreateTokens, DeleteToken, GetTokenss, UpdateToken, GetTokens} from "../../services/token.service";
import {toast} from "react-toastify";
import {constants, customStyles} from "../../utils/constants";
import moment from "moment"
import {useHistory} from 'react-router-dom';
import DataTable from 'react-data-table-component';
import BarLoader from "react-spinners/BarLoader";
import {EmptyLocalStorage} from "../../services/auth/auth.service";

function TokenList() {
    let history = useHistory();
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(constants.PERPAGE);
    const [rows, setRows] = useState();

    useEffect(async () => {
        await getTokens();
    }, [page, perPage])

    const getTokens = async () => {
        setLoading(true)
        await GetTokens(page, perPage).then((result) => {
            if (result.status) {
                if (result.data) {
                    const rowData = [];
                    // setPage(result.data.meta.current_page)
                    // setTotalRows(result.data.meta.total);
                    result.data.map((dt, index) => {
                        rowData.push({
                            id: dt.id,
                            index: ++index,
                            name: dt?.name || '-',
                            tokens: dt?.tokens || 0,
                            total_amount: dt?.total_amount || 0,
                            recommended: dt?.recommended,
                            status: dt?.status
                        });
                    })
                    setRows(rowData);
                    setLoading(false)
                }
            } else {
                setLoading(false)
                return toast.error(result.message);
            }
        }).catch((error) => {
            setLoading(false)
            if (error.response.status == 401) {
                EmptyLocalStorage()
                history.push('/');
            } else {
                return toast.error(error.response.data.message);
            }
        })
    }


    const onTokenDelete = (id) => {
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to delete this token?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willShip) => {
            //Delete Product API
            if (willShip) {
                await DeleteToken(id).then((result) => {
                    if (result.status) {
                        swal(result.message, {
                            icon: "success",
                        });
                        getTokens()
                    } else {
                        toast.error(result.message);
                    }
                }).catch((error) => {
                    if (error.response.status == 401) {
                        EmptyLocalStorage()
                        history.push('/');
                    } else {
                        return toast.error(error.response.data.message);
                    }
                })
            }
        });
    }

    const onEdit = (data) => {
        history.push('/edit-tokens/' + data.id, {
            data: data
        });
    }

    // const onViewPage = (data) => {
    //     history.push('/page/' + data.slug);
    // }

    const pageActions = (data) => {
        return (
            <DropdownButton align="end" className={"actionDropdown"} id="dropdown-item-button" title={<MenuDots/>}>
                <Dropdown.Item as="button" onClick={() => onViewPage(data)}>View</Dropdown.Item>
                <Dropdown.Item as="button" onClick={() => onEdit(data)}>Edit</Dropdown.Item>
                <Dropdown.Item as="button" onClick={() => onTokenDelete(data.id)}>Delete</Dropdown.Item>
            </DropdownButton>
        )
    }
    const onViewPage = (data) => {

        console.log(data)
        history.push('/view-token/' +data.id);
    }

    const columns = [
        /*{
            id: 'delete',
            maxWidth: "0%",
            selector: rowData => rowData.id,

        },*/
        {
            id: 'name',
            name: 'Name',

            selector: rowData => rowData.name,
        },
        {
            id: 'token',
            name: 'Tokens',

            selector: rowData => rowData.tokens,
        },
        {
            id: 'total_amount',
            name: 'Total Amount',

            selector: rowData => rowData.total_amount,
        },
        {
            id: 'recommended',
            name: 'Recommended',

            selector: rowData => rowData.recommended,
        },
        {
            id: 'status',
            name: 'Status',

            selector: rowData => rowData.status,
        },
        {
            id: 'action',
            name: 'Action',
            cell: rowData => pageActions(rowData)
        },
    ];

    const data = [
        {
            id: 1,
            keyword: "abc123"
        },
        {
            id: 2,
            keyword: "Corey Morgan"
        },
        {
            id: 3,
            keyword: "Corey Morgan",
        },
        {
            id: 4,
            keyword: "Corey Morgan",
        },
        {
            id: 5,
            keyword: "Corey Morgan",
        },
    ];

    const handlePageChange = async (page) => {
        await setPage(page);
    };

    return (
        <div className={"PageList"}>
            <h3 className="page-heading">Tokens</h3>
            <hr/>
            <div className={"customOrderFilters"}>
                <Row>
                    <Col xs={12} sm={12} md={{span: 3, offset: 9}} lg={{span: 3, offset: 9}} xl={{span: 3, offset: 9}}>
                        <Link to={"/add-tokens"}>
                            <Button className={"btn btn-green-theme h40 w-100"}>
                                <AddIconOutline/> Add New
                            </Button>
                        </Link>
                    </Col>
                </Row>
            </div>
            <div className={"mt-3"}>
                <div className="theme-dataGrid products-dataGrid">
                    <DataTable
                        columns={columns}
                        data={rows}
                        progressPending={loading}
                        customStyles={customStyles}
                        selectableRows={false}
                        striped
                        highlightOnHover
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={perPage}
                        onChangePage={(page) => {
                            setPage(page);
                        }}
                        onChangeRowsPerPage={(currentRowsPerPage) => {
                            setPerPage(currentRowsPerPage)
                        }}
                        progressComponent={<BarLoader color={'#3D2570'} loading={loading} css={'marginTop: 10px'}
                                                      height={'4'} width={'100%'}/>}
                    />
                </div>
            </div>
        </div>
    )
}

export default TokenList
